import { call, cancelled, put, select, take } from 'redux-saga/effects';
import { clearMessage, ERROR, setMessage } from '../../containers/FormMessage/actions';
import { CONNECTED as PDS_CONNECTED, CONNECTION_ERROR as PDS_CONNECTION_ERROR } from '../pds/actions';
import createChannel from './channels';

export default function* watchPDSChangesV6(topicSelector, filteredActions = null) {
  const pdsTopicParams = yield select(topicSelector);
  if (pdsTopicParams.isEmpty()) {
    return;
  }

  const channel = yield call(createChannel, pdsTopicParams);

  try {
    while (true) {
      const action = yield take(channel);
      if (action.type === PDS_CONNECTION_ERROR) {
        yield put(setMessage(
          ERROR,
          'Connection lost for live events. Trying to reconnect...',
          null,
          true,
          'live_events'
        ));
      } else if (action.type === PDS_CONNECTED) {
        yield put(clearMessage('live_events'));
      }
      if (filteredActions === null || filteredActions.includes(action.type)) {
        yield put(action);
      }
    }
  } finally {
    if (yield cancelled()) {
      channel.close();
    }
  }
}
